export const getReloadYard = /* GraphQL */ `
  query GetReloadYard($id: ID!) {
    getReloadYard(id: $id) {
      id
      owner
      groups
      active
      status
      name
      phone
      fax
      email
      website
      street
      city
      state
      zipCode
      country
      timeZone
      latitude
      longitude
      geofence
      geofenceToleranceMeters
      geofenceEnabled
      geofenceEnforced
      driverCheckInEnabled
      driverIdentificationRequired
      driverIdScanRequired
      driverCheckInGraceMinutes
      driverCheckInWithoutAppointment
      driverInstructions
      postCheckInMessage
      driverStops {
        label
        message
      }
      lotCapacity
      trackCapacity
      warehouseCapacity
      servingCarrier
      railHighway
      ast
      externalCompanyId
      taxRates {
        taxCode
        name
        taxRate
      }
      paymentTerms {
        items {
          id
          name
          code
          type
          dueDays
          # dayOfMonthDue
          sortKey
        }
      }
      invoiceNumberPrefix
      invoiceCounter
      remittanceAddress {
        name
        street
        city
        state
        zipCode
        country
      }
      bolTemplate {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      receiptTemplate {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      # bolCounter
      # receiptCounter
      fileCategories {
        key
        name
      }
      mapImage {
        bucket
        region
        key
      }
      logoImage {
        bucket
        region
        key
      }
      checklists {
        items {
          id
          owner
          groups
          active
          reloadYardId
          resourceId
          name
          description
          processName
          reloadYardCommodityId
          createdBy
          createdAt
          updatedAt
        }
      }
      areas {
        items {
          id
          active
          name
          prefix
          areaType
          color
          sortKey
          zones {
            items {
              id
              active
              name
              prefix
              accountId
              reloadYardCommodityId
              areaId
              color
              sortKey
            }
            nextToken
          }
        }
        nextToken
      }
      aisles {
        items {
          id
          owner
          groups
          active
          reloadYardId
          name
          areaId
          area {
            id
            active
            name
            prefix
            color
            areaType
            sortKey
          }
          zoneId
          zone {
            id
            active
            name
            prefix
            accountId
            reloadYardCommodityId
            areaId
            color
            sortKey
          }
          capacityUsed
          type
          bays
          levels
          length
          width
          sortKey
        }
        nextToken
      }
      yardCommodities {
        items {
          id
          active
          reloadYardId
          commodityId
          units
          sortKey
          commodity {
            id
            name
            description
            locationLoadType
            validUom
            inventoryFields
          }
        }
        nextToken
      }
      railEquipmentTypes {
        items {
          id
          name
          arrTypeCode
          length
          sortKey
        }
        nextToken
      }
      truckEquipmentTypes {
        items {
          id
          name
          length
          sortKey
        }
        nextToken
      }
      subscription {
        customerId
        subscriptionId
        priceId
        name
        status
      }
      tosAccept {
        acceptTimeStamp
        cognitoId
        email
        userAgent
        ip
      }
      eventTypes {
        items {
          id
          active
          areaId
          name
          description
          duration
          bufferTime
          resourceName
          numberOfResources
          schedule {
            workdays {
              id
              name
              startDayTime
              endDayTime
              selected
            }
            holidays
            minNoticeHours
            maxDaysIntoFuture
          }
        }
        nextToken
      }
      schedule {
        workdays {
          id
          name
          startDayTime
          endDayTime
          selected
        }
        holidays
        minNoticeHours
        maxDaysIntoFuture
        layout
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      notes {
        type
        date
        by
        text
        public
      }
      createdAt # required for reporting
    }
  }
`;

export const countInvoices = /* GraphQL */ `
  query SearchInvoices(
    $filter: SearchableInvoiceFilterInput
    $sort: SearchableInvoiceSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchInvoices(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      total
    }
  }
`;
export const zapByActiveByEvent = /* GraphQL */ `
  query ZapByActiveByEvent(
    $reloadYardId: ID
    $activeEvent: ModelZapierHookZapByActiveByEventCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelZapierHookFilterInput
    $limit: Int
    $nextToken: String
  ) {
    zapByActiveByEvent(
      reloadYardId: $reloadYardId
      activeEvent: $activeEvent
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        event
        options
        createdAt
      }
      nextToken
    }
  }
`;

export const getInvoiceCounter = /* GraphQL */ `
  query GetReloadYard($id: ID!) {
    getReloadYard(id: $id) {
      id
      active
      name
      invoiceCounter
      invoiceNumberPrefix
    }
  }
`;

export const getBOLCounter = /* GraphQL */ `
  query GetReloadYard($id: ID!) {
    getReloadYard(id: $id) {
      active
      name
      bolCounter
    }
  }
`;

export const getReceiptCounter = /* GraphQL */ `
  query GetReloadYard($id: ID!) {
    getReloadYard(id: $id) {
      active
      name
      receiptCounter
    }
  }
`;

export const customerByEmail = /* GraphQL */ `
  query CustomerByEmail(
    $email: String
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customerByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        cognitoId
        email
        firstName
        lastName
        phone
        reloadYardAccounts {
          items {
            id
            active
            groups
            reloadYardId
            accountId
            accountName
            acl
            account {
              inboundAdviceInputs
              outboundAdviceInputs
            }
            reloadYard {
              id
              name
              phone
              fax
              email
            }
          }
          nextToken
        }
      }
    }
  }
`;

export const userByEmailMini = /* GraphQL */ `
  query UserByEmail(
    $email: String
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        groups
        active
        status
        reloadYardId
        cognitoId
        lastName
      }
      nextToken
    }
  }
`;

export const customerByEmailMini = /* GraphQL */ `
  query CustomerByEmail(
    $email: String
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customerByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        cognitoId
        lastName
        reloadYardAccounts {
          items {
            id
            active
          }
        }
      }
      nextToken
    }
  }
`;

export const getCustomerReloadYardAccountMini = /* GraphQL */ `
  query GetCustomerReloadYardAccount($id: ID!) {
    getCustomerReloadYardAccount(id: $id) {
      id
      active
      groups
      accountId
      accountName
      acl
      account {
        inboundAdviceInputs
        outboundAdviceInputs
      }
    }
  }
`;

export const aisleByActiveByZoneBySortKey = /* GraphQL */ `
  query AisleByActiveByZoneBySortKey(
    $zoneId: ID
    $activeSortKey: ModelAisleAisleByActiveByZoneBySortKeyCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAisleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    aisleByActiveByZoneBySortKey(
      zoneId: $zoneId
      activeSortKey: $activeSortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          areaId
          color
          zoneType
          sortKey
          createdAt
          updatedAt
        }
        bays
        levels
        capacityUsed
        totalLocations
        locationLoad {
          other {
            selected
            capacity
          }
          pallet {
            selected
            capacity
          }
          box {
            selected
            capacity
          }
          container {
            selected
            capacity
          }
          superSack {
            selected
            capacity
          }
          dryBulk {
            selected
            capacity
          }
          liquidBulk {
            selected
            capacity
          }
        }
        topDownPickOrder
        length
        width
        sortKey
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const aisleByActiveBySortKey = /* GraphQL */ `
  query AisleByActiveBySortKey(
    $reloadYardId: ID
    $activeSortKey: ModelAisleAisleByActiveBySortKeyCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAisleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    aisleByActiveBySortKey(
      reloadYardId: $reloadYardId
      activeSortKey: $activeSortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          areaId
          color
          zoneType
          sortKey
          createdAt
          updatedAt
        }
        locations(filter: { active: { eq: "true" } }) {
          items {
            id
            owner
            groups
            active
            reloadYardId
            capacityUsed
            capacityAllocated
            bulkCapacity
            bulkUnits
            isContaminated
            name
            productId
            type
            areaId
            area {
              id
              active
              name
              prefix
              areaType
              color
              sortKey
            }
            zoneId
            zone {
              id
              active
              areaId
              name
              prefix
              accountId
              color
              sortKey
            }
            aisleId
            bay
            level
            position
            length
            width
            sortKey
          }
          nextToken
        }
        bays
        levels
        positions
        capacityUsed
        locationLoad {
          other {
            selected
            capacity
          }
          pallet {
            selected
            capacity
          }
          box {
            selected
            capacity
          }
          container {
            selected
            capacity
          }
          superSack {
            selected
            capacity
          }
          dryBulk {
            selected
            capacity
          }
          liquidBulk {
            selected
            capacity
          }
        }
        length
        width
        sortKey
        topDownPickOrder
        totalLocations
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const locationByAisleBySortKey = /* GraphQL */ `
  query LocationByAisleBySortKey(
    $aisleId: ID
    $sortKey: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    locationByAisleBySortKey(
      aisleId: $aisleId
      sortKey: $sortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        productId
        productName
        accountName
        name
        type
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          areaId
          color
          zoneType
          reloadYardCommodityId
          sortKey
        }
        aisleId
        aisle {
          id
          active
          reloadYardId
          name
          type
          areaId
          zoneId
          bays
          levels
          topDownPickOrder
          totalLocations
          locationLoad {
            other {
              selected
              capacity
            }
            pallet {
              selected
              capacity
            }
            box {
              selected
              capacity
            }
            container {
              selected
              capacity
            }
            superSack {
              selected
              capacity
            }
            dryBulk {
              selected
              capacity
            }
            liquidBulk {
              selected
              capacity
            }
          }
          length
          width
          sortKey
          topDownPickOrder
        }
        bay
        level
        position
        locationLoad {
          other {
            selected
            capacity
          }
          pallet {
            selected
            capacity
          }
          box {
            selected
            capacity
          }
          container {
            selected
            capacity
          }
          superSack {
            selected
            capacity
          }
          dryBulk {
            selected
            capacity
          }
          liquidBulk {
            selected
            capacity
          }
        }
        capacityUsed
        capacityAllocated
        bulkCapacity
        bulkUnits
        isContaminated
        length
        width
        sortKey
      }
      nextToken
    }
  }
`;

export const areaByActiveBySortKey = /* GraphQL */ `
  query AreaByActiveBySortKey(
    $reloadYardId: ID
    $activeSortKey: ModelAreaAreaByActiveBySortKeyCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAreaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    areaByActiveBySortKey(
      reloadYardId: $reloadYardId
      activeSortKey: $activeSortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        active
        name
        prefix
        areaType
        sortKey
        zones {
          items {
            id
            active
            name
            prefix
            accountId
            leasedArea
            leasedAreaUOM
            reloadYardCommodityId
            areaId
            color
            sortKey
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;

export const getAisle = /* GraphQL */ `
  query GetAisle($id: ID!) {
    getAisle(id: $id) {
      id
      owner
      groups
      active
      reloadYardId
      name
      type
      areaId
      area {
        id
        active
        name
        prefix
        color
        areaType
        sortKey
      }
      zoneId
      zone {
        id
        active
        name
        prefix
        accountId
        areaId
        color
        zoneType
        sortKey
      }
      locations {
        items {
          id
          active
          name
          type
          areaId
          zoneId
          aisleId
          area {
            id
            active
            name
            prefix
            areaType
            sortKey
          }
          zone {
            id
            active
            name
            prefix
            accountId
            areaId
            sortKey
          }
          aisle {
            id
            active
            name
            type
            bays
            levels
            capacityUsed
            length
            width
            sortKey
          }
          locationLoad {
            other {
              selected
              capacity
            }
            pallet {
              selected
              capacity
            }
            box {
              selected
              capacity
            }
            container {
              selected
              capacity
            }
            superSack {
              selected
              capacity
            }
            dryBulk {
              selected
              capacity
            }
            liquidBulk {
              selected
              capacity
            }
          }
          bay
          level
          position
          capacityUsed
          capacityAllocated
          sortKey
        }
        nextToken
      }
      bays
      levels
      locationLoad {
        other {
          selected
          capacity
        }
        pallet {
          selected
          capacity
        }
        box {
          selected
          capacity
        }
        container {
          selected
          capacity
        }
        superSack {
          selected
          capacity
        }
        dryBulk {
          selected
          capacity
        }
        liquidBulk {
          selected
          capacity
        }
      }
      capacityUsed
      length
      width
      sortKey
      createdAt
      updatedAt
    }
  }
`;

export const aisleByActiveByAreaBySortKey = /* GraphQL */ `
  query AisleByActiveByAreaBySortKey(
    $areaId: ID
    $activeSortKey: ModelAisleAisleByActiveByAreaBySortKeyCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAisleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    aisleByActiveByAreaBySortKey(
      areaId: $areaId
      activeSortKey: $activeSortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        type
        areaId
        area {
          active
          name
          areaType
          prefix
          color
        }
        zoneId
        zone {
          id
          active
          name
          prefix
          accountId
          color
          zoneType
          sortKey
        }
        locationLoad {
          other {
            selected
            capacity
          }
          pallet {
            selected
            capacity
          }
          box {
            selected
            capacity
          }
          container {
            selected
            capacity
          }
          superSack {
            selected
            capacity
          }
          dryBulk {
            selected
            capacity
          }
          liquidBulk {
            selected
            capacity
          }
        }
        locations {
          items {
            id
            active
            name
            type
            areaId
            zoneId
            aisleId
            bay
            level
            position
            capacityUsed
            capacityAllocated
            bulkCapacity
            bulkUnits
            isContaminated
            locationLoad {
              other {
                selected
                capacity
              }
              pallet {
                selected
                capacity
              }
              box {
                selected
                capacity
              }
              container {
                selected
                capacity
              }
              superSack {
                selected
                capacity
              }
              dryBulk {
                selected
                capacity
              }
              liquidBulk {
                selected
                capacity
              }
            }
            sortKey
          }
        }
        bays
        levels
        capacityUsed
        topDownPickOrder
        totalLocations
        sortKey
      }
      nextToken
    }
  }
`;

export const aisleByActiveByAreaBySortKeyLocations = /* GraphQL */ `
  query AisleByActiveByAreaBySortKey(
    $areaId: ID
    $activeSortKey: ModelAisleAisleByActiveByAreaBySortKeyCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAisleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    aisleByActiveByAreaBySortKey(
      areaId: $areaId
      activeSortKey: $activeSortKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        active
        reloadYardId
        name
        type
        areaId
        area {
          id
          active
          name
          prefix
          areaType
          sortKey
        }
        zoneId
        zone {
          id
          active
          name
          prefix
          accountId
          reloadYardCommodityId
          areaId
          color
          zoneType
          sortKey
        }
        locations {
          items {
            id
            groups
            active
            reloadYardId
            name
            type
            areaId
            zoneId
            aisleId
            position
            capacityUsed
            capacityAllocated
            length
            width
            sortKey
          }
          nextToken
        }
        capacityUsed
        length
        width
        sortKey
      }
      nextToken
    }
  }
`;

export { eventTypeByActiveByArea } from "../event/event-queries";

// Focused query to refresh a yard's load-type (commodity) metadata only.
// Used to re-hydrate window.appUser.reloadYard.yardCommodityMap when a long-lived
// session holds commodity records that predate schema additions (e.g. validUom /
// inventoryFields), which otherwise requires a full page reload to pick up.
export const getReloadYardCommodities = /* GraphQL */ `
  query GetReloadYardCommodities($id: ID!) {
    getReloadYard(id: $id) {
      id
      yardCommodities {
        items {
          id
          active
          reloadYardId
          commodityId
          units
          sortKey
          commodity {
            id
            name
            description
            locationLoadType
            validUom
            inventoryFields
          }
        }
        nextToken
      }
    }
  }
`;

// Lean yard-wide timeslot query for capacity math. Unlike the generated
// timeslotByYearByWeek, which hydrates the full inbound/outbound shipment
// connections, this fetches only the shipment status — needed to exempt
// RELEASED bookings from capacity (getOccupiedIntervals).
export const timeslotByYearByWeekForCapacity = /* GraphQL */ `
  query TimeslotByYearByWeek(
    $reloadYardId: ID
    $yearWeek: ModelTimeslotTimeslotByYearByWeekCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTimeslotFilterInput
    $limit: Int
    $nextToken: String
  ) {
    timeslotByYearByWeek(
      reloadYardId: $reloadYardId
      yearWeek: $yearWeek
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        eventTypeId
        time
        month
        day
        year
        week
        startTime
        endTime
        inboundShipment {
          status
        }
        outboundShipment {
          status
        }
      }
      nextToken
    }
  }
`;

// Lists ALL of a yard's event types (active AND inactive) with the hydrated
// asset cap. Capacity math needs deactivated event types too — their bookings
// still occupy the yard.
export const listEventTypesForCapacity = /* GraphQL */ `
  query ListEventTypes(
    $filter: ModelEventTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventTypes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        active
        duration
        bufferTime
        numberOfResources
        assetTypeId
        assetType {
          id
          maxConcurrentBookings
        }
      }
      nextToken
    }
  }
`;
